import __vue_component__ from './SpotlightHint.vue.js';

var script = {
  name: 'SpotlightOverlay',
  inject: ['$spotlight'],
  computed: {
    currentSpotlight() {
      return this.$spotlight.currentSpotlight;
    },

    components() {
      return this.currentSpotlight && this.currentSpotlight.components || [];
    },

    step() {
      return this.$spotlight.currentStep;
    },

    total() {
      return this.$spotlight.spotlights.length;
    }

  },

  mounted() {
    this.$spotlight.registerOverlay(this);
  },

  render(h) {
    return h('div', {
      class: 'spotlight-overlay',
      attrs: {
        visible: Boolean(this.currentSpotlight)
      },
      on: {
        click: e => e.stopPropagation()
      }
    }, this.components.map((component, index) => {
      const {
        target,
        message,
        placement,
        offset
      } = component;
      return h(__vue_component__, {
        class: 'spotlight-hint',
        props: {
          targetElement: target.elm || document.body,
          step: this.$spotlight.currentStep,
          total: this.$spotlight.lastStep,
          placement,
          offset
        },
        scopedSlots: message ? {
          default: () => message
        } : undefined,
        key: `spotlight-hint-${this.$spotlight.currentStep}-${index}`,
        on: {
          next: this.$spotlight.next,
          prev: this.$spotlight.prev,
          close: this.$spotlight.close
        }
      });
    }));
  }

};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Spotlight/SpotlightOverlay.vue_rollup-plugin-vue=script.js